import React, { useState } from 'react'
import { Stepper } from '@clickcease/cc-client-components-lib'

import { MultiDomainsContainer, StepperWrapper } from './MultipleDomains.styles'
import { SelectOption } from 'Types/Option'
import { AddDomainsStep } from './AddDomainsStep'
import { DomainToProduct } from './DomainToProduct'

interface MultipleDomainsProps {
  onOpenChange: (a: boolean | number) => void
}

export const joinArrays = (arr1: SelectOption[], arr2: SelectOption[]) => {
  const newArr = [...arr1, ...arr2]
  const uniqueArr = newArr.filter(
    (item, index) => newArr.findIndex((item2) => item2.value === item.value) === index
  )
  return uniqueArr
}

export const MultipleDomains = ({ onOpenChange }: MultipleDomainsProps) => {
  const [step, setStep] = useState(1)
  const [domains, setDomains] = useState<SelectOption[]>([])

  const handleAddDomain = (domains: SelectOption[]) => {
    // allow deleting domains
    setDomains((prev) => (prev.length > domains.length ? domains : joinArrays(domains, prev)))
  }

  const onFinishDomains = () => {
    setStep(2)
  }

  return (
    <MultiDomainsContainer>
      <StepperWrapper>
        <Stepper currentStep={step} steps={2} onChangeStep={setStep} />
      </StepperWrapper>
      {step === 1 && (
        <AddDomainsStep
          onOpenChange={onOpenChange}
          domains={domains}
          setDomains={handleAddDomain}
          finishStep={onFinishDomains}
        />
      )}
      {step === 2 && <DomainToProduct onOpenChange={onOpenChange} domains={domains} />}
    </MultiDomainsContainer>
  )
}
